// @ts-nocheck
import List from '@material-ui/core/List';
import { CommentOutlined, Domain, GridOn, GridOnOutlined, History } from '@material-ui/icons';
import AtlasIcon from '@material-ui/icons/Airplay';
import SettingsIcon from '@material-ui/icons/BrightnessLow';
import HyperGateIcon from '@material-ui/icons/Cast';
import SnippetIcon from '@material-ui/icons/Code';
import CardIcon from '@material-ui/icons/CreditCard';
import RegistryIcon from '@material-ui/icons/HdrWeak';
import InvitationsIcon from '@material-ui/icons/InsertLink';
import LockIcon from '@material-ui/icons/LockOpen';
import RolesIcon from '@material-ui/icons/Security';
import AnalyticsIcon from '@material-ui/icons/ShowChart';
import TabletIcon from '@material-ui/icons/Tablet';
import GatewayIcon from '@material-ui/icons/WifiTethering';
import { withStyles } from '@material-ui/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { LICENSE_TYPES, PERMISSIONS, PERMISSION_ENTITIES, SUBSCRIPTION_TYPES } from '../_config/consts';
import { getPlantName } from '../_config/utils';
import AccessProfilesIconCustom from '../components/CustomIcons/AccessProfilesIconCustom.jsx';
import AdminEventsIconCustom from '../components/CustomIcons/AdminEventsIconCustom.jsx';
import AgendaIconCustom from '../components/CustomIcons/AgendaIconCustom.jsx';
import AlarmIconCustom from '../components/CustomIcons/AlarmIconCustom.jsx';
import AreasManagementIconCustom from '../components/CustomIcons/AreasManagementIconCustom.jsx';
import BookeyAvailabilityIconCustom from '../components/CustomIcons/BookeyAvailabilityIconCustom.jsx';
import CameraIconCustom from '../components/CustomIcons/CameraIconCustom.jsx';
import ChartBoxIconCustom from '../components/CustomIcons/ChartBoxIconCustom.jsx';
import CommunicationIconCustom from '../components/CustomIcons/CommunicationIconCustom.jsx';
import CopyIconCustom from '../components/CustomIcons/CopyIconCustom.jsx';
import DashboardIconCustom from '../components/CustomIcons/DashboardIconCustom.jsx';
import DoorClosedIconCustom from '../components/CustomIcons/DoorClosedIconCustom.jsx';
import EnergyManagementIconCustom from '../components/CustomIcons/EnergyManagementIconCustom.jsx';
import EventIconCustom from '../components/CustomIcons/EventIconCustom.jsx';
import InstallerOutlinedIconCustom from '../components/CustomIcons/InstallerOutlinedIconCustom.jsx';
import IntercomExtensionIconCustom from '../components/CustomIcons/IntercomExtensionIconCustom.jsx';
import IntercomIconCustom from '../components/CustomIcons/IntercomIconCustom.jsx';
import IntercomManagementIconCustom from '../components/CustomIcons/IntercomManagementIconCustom.jsx';
import KeyOutlinedIconCustom from '../components/CustomIcons/KeyOutlinedIconCustom.jsx';
import ListBoxIconCustom from '../components/CustomIcons/ListBoxIconCustom.jsx';
import MapIconCustom from '../components/CustomIcons/MapIconCustom.jsx';
import MessageAlertIconCustom from '../components/CustomIcons/MessageAlertIconCustom.jsx';
import PackageCheckIconCustom from '../components/CustomIcons/PackageCheckIconCustom.jsx';
import PackageIconCustom from '../components/CustomIcons/PackageIconCustom.jsx';
import PeopleTrackingIconCustom from '../components/CustomIcons/PeopleTrackingIconCustom.jsx';
import PickupPointIconCustom from '../components/CustomIcons/PickupPointIconCustom.jsx';
import PinIconCustom from '../components/CustomIcons/PinIconCustom.jsx';
import PlatformUserIconCustom from '../components/CustomIcons/PlatformUserIconCustom.jsx';
import PrivateUnitsIconCustom from '../components/CustomIcons/PrivateUnitsIconCustom.jsx';
import SmartLocksEventsIconCustom from '../components/CustomIcons/SmartLocksEventsIconCustom.jsx';
import SmartPhoneKeyIconCustom from '../components/CustomIcons/SmartPhoneKeyIconCustom.jsx';
import StoreOutlinedIconCustom from '../components/CustomIcons/StoreOutlinedIconCustom.jsx';
import SubcompanyEventIconCustom from '../components/CustomIcons/SubcompanyEventIconCustom.jsx';
import TableKeyIconCustom from '../components/CustomIcons/TableKeyIconCustom.jsx';
import TagIconCustom from '../components/CustomIcons/TagIconCustom.jsx';
import UsersIconCustom from '../components/CustomIcons/UsersIconCustom.jsx';
import VisitorsIconCustom from '../components/CustomIcons/VisitorsIconCustom.jsx';
import WearableIconCustom from '../components/CustomIcons/WearableIconCustom.jsx';
import Permission from '../components/Permission/Permission.jsx';
import AbilityProvider from '../permissionsUtils/AbilityProvider.js';
import * as UserActions from '../redux/actions/user.actions';
import * as UtilsActions from '../redux/actions/utils.actions';
import {
  CollapsibleMenu,
  MenuItem,
  MenuItemRenderer,
  SidebarFavoritesSection,
  SidebarNavContext,
  SidebarSearchField,
  SidebarSection,
  SidebarThemeRoot,
  sidebarStyles as styles,
} from './AppSidebarShared.jsx';
import {
  getSidebarFavorites,
  toggleSidebarFavorite,
} from './sidebarFavorites.js';

@withRouter
@connect(state => ({
  userToken: state.user.token,
  customTables: state.customTables,
  routing: state.router,
  userLicense: state.user.license,
  user: state.user,
  themeData: state.settings.items.theme.data,
  themeName: state.settings.items.theme.data.themeName,
  subcompanies: state.settings.subcompanies,
}))
class AppSidebar extends React.Component {

  constructor(props) {
    super(props);
    this.menuIconRegistry = {};
    this.state = {
      isGatewayDropdownOpened: false,
      isEventsDropdownOpened: false,
      marketplaceCollapseOpen: false,
      isTicketingDropdownOpen: false,
      isParcelDropdownOpen: false,
      isIntercomDropdownOpen: false,
      isWearablesDropdownOpen: false,
      sidebarSearchQuery: '',
      sidebarFavorites: [],
    };
    this.onSidebarSearchChange = this.onSidebarSearchChange.bind(this);
    this.onToggleSidebarFavorite = this.onToggleSidebarFavorite.bind(this);
    this.registerMenuIcon = this.registerMenuIcon.bind(this);
    this.getFavoriteIcon = this.getFavoriteIcon.bind(this);
    this.syncSidebarFavorites = this.syncSidebarFavorites.bind(this);
  }

  componentDidMount() {
    this.syncSidebarFavorites();
  }

  componentWillReceiveProps(nextProps) {
    const userId = this.props.user && this.props.user.data && this.props.user.data.id;
    const nextUserId = nextProps.user && nextProps.user.data && nextProps.user.data.id;
    if (userId !== nextUserId) {
      this.syncSidebarFavorites(nextProps);
    }
  }

  syncSidebarFavorites(props = this.props) {
    const userId = props.user && props.user.data && props.user.data.id;
    this.setState({ sidebarFavorites: getSidebarFavorites(userId) });
  }

  onSidebarSearchChange(value) {
    this.setState({ sidebarSearchQuery: value });
  }

  onToggleSidebarFavorite(favoriteEntry) {
    const userId = this.props.user && this.props.user.data && this.props.user.data.id;
    const nextFavorites = toggleSidebarFavorite(
      userId,
      this.state.sidebarFavorites,
      favoriteEntry,
    );
    this.setState({ sidebarFavorites: nextFavorites });
  }

  registerMenuIcon(menuId, icon) {
    if (!menuId) {
      return;
    }
    this.menuIconRegistry[menuId] = icon;
  }

  getFavoriteIcon(menuId) {
    return this.menuIconRegistry[menuId] || null;
  }
  
  render() {
    const { dispatch, themeData, userLicense, subcompanies, location, user, classes } = this.props;
    const companyLogo = themeData && themeData.logo;
    const licenseType = userLicense && userLicense.domainProductType;
    const canReadGuest = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER);
    const canReadLocks = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const canReadGateways = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.GATEWAY);
    const canReadAccesRules = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.CREDENTIAL_RULE);
    const canReadCards = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canReadLogs = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.LOG);
    const canEditGuestsTags = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER_TAG);
    const canEditLocksTags = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK_TAG);
    const hideAccessRuleMenu =  (!canReadGuest && !canReadLocks && !canReadGateways && !canReadLogs && !canEditLocksTags && !canEditGuestsTags);
    const hideCredentialsRulesMenu = !canReadAccesRules && !canReadCards;
    const isInvitationPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.INVITATIONS)) || dispatch(UtilsActions.isPrivateUnitsActive());
    const isInvitationReadOnlyIntegrationActive = dispatch(UtilsActions.isInvitationReadOnlyIntegrationActive());
    const isBookeyActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.BOOKEY));
    const isTicketingManagementActive = dispatch(UtilsActions.isTicketingManagementActive());
    const isCapacityManagementActive = dispatch(UtilsActions.isCapacityManagementActive());
    const isEnergyManagementActive = dispatch(UtilsActions.isEnergyManagementActive());
    const isItemRegistryPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.REGISTRY));
    const isCommunicationPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.COMMUNICATIONS));
    const isF9000PluginActive = dispatch(UserActions.isF9000AddonActive());
    const isMarketPlaceEnabled = dispatch(UserActions.isMarketPlaceEnabled());
    const isFakeCloudCredits = dispatch(UserActions.isFakeCloudCredits());
    const isCameraSectionActive = dispatch(UtilsActions.isEagleEyeIntegrationActive());
    const hasSharedLocks = dispatch(UtilsActions.hasSharedLocks());
    const isAccessProfileAddonActive = dispatch(UtilsActions.isAccessProfileAddonActive());
    const isVisitorsManagementActive = dispatch(UtilsActions.isVisitorsManagementActive());
    const isPrivateUnitsActive = dispatch(UtilsActions.isPrivateUnitsActive())
    const isParcelManagementActive = dispatch(UtilsActions.isParcelManagementActive());
    const isBookeyCapacityActive = dispatch(UtilsActions.isBookeyCapacityActive());
    const isWalletPendingOrReady = dispatch(UserActions.isWalletPendingActivationOrReadyToActivate());
    const isIntercomManagementActive = dispatch(UtilsActions.isIntercomManagementActive());
    const isCustomTablesActive = dispatch(UtilsActions.isCustomTablesActive());
    const isWearablesManagementActive = dispatch(UtilsActions.isWearablesManagementActive());
    const isHyperTouchManagementActive = dispatch(UtilsActions.isHyperTouchManagementActive());
    const isCustomActionsActive = false;
    const { customTables: { data: { content: customTablesData } } } = this.props;
    const isMksManagementActive = dispatch(UtilsActions.isMksManagementActive());
    const systemHasAtlas = user.systemHasAtlas;
    const { themeName } = this.props;
    const { sidebarSearchQuery, sidebarFavorites } = this.state;
    const sidebarNavContextValue = {
      searchQuery: sidebarSearchQuery,
      sidebarFavorites,
      onToggleFavorite: this.onToggleSidebarFavorite,
      registerMenuIcon: this.registerMenuIcon,
    };
    const navContent = (
      <List component="nav" className={classes.sidebar}>
          {!hideAccessRuleMenu && (
            <SidebarSection sectionKey="plantManagement" headerEntity="plantManagement">
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  entityKey="dashboard"
                  path="/dashboard"
                  icon={<DashboardIconCustom className={classes.icon} />}
                  title={<Entity entity="dashboard" />}
                  isSelected={location && location.pathname && location.pathname === '/dashboard'}
                  onClick={() => dispatch(push('/dashboard'))}
                />
              </Permission>
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/guests"
                  icon={<UsersIconCustom className={classes.icon} style={{ width: 24.5 }} />}
                  entityKey="guests"
                  title={<Entity entity="guests" />}
                  isSelected={location && location.pathname && location.pathname === '/guests'}
                  onClick={() => dispatch(push('/guests'))}
                />
              </Permission>
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.SMART_LOCK} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/locks"
                  icon={<LockIcon className={classes.icon} />}
                  entityKey="locks"
                  title={<Entity entity="locks" />}
                  isSelected={location && location.pathname && location.pathname === '/locks'}
                  onClick={() => dispatch(push('/locks'))}
                />
              </Permission>
              {isCustomTablesActive && customTablesData && customTablesData.length > 0 ? (
                <>
                  {_.map(customTablesData, (customTable) => (
                    <MenuItem
                      showFavoriteControl
                      path={`/customTableDisplayView/${customTable.id}`}
                      menuId={`/customTableDisplayView/${customTable.id}`}
                      iconKey="customTable"
                      searchLabel={customTable.name}
                      icon={<GridOn className={classes.icon} />}
                      title={customTable.name}
                      isSelected={location && location.pathname && location.pathname === `/customTableDisplayView/${customTable.id}`}
                      onClick={() => dispatch(push(`/customTableDisplayView/${customTable.id}`, { customTable: customTable }))}
                    />
                  ))}
                </>
              ) : null}
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                {isCameraSectionActive ? (
                  <MenuItem
                    showFavoriteControl
                    path="/cameras"
                    icon={<CameraIconCustom className={classes.icon} />}
                    iconStyle={{ width: 23 }}
                    entityKey="cameras"
                  title={<Entity entity="cameras" />}
                    isSelected={location && location.pathname && location.pathname === '/cameras'}
                    onClick={() => dispatch(push('/cameras'))}
                  />
                ) : null}
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.LITE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/gateways"
                  icon={<HyperGateIcon className={classes.icon} />}
                  containerStyle={{ marginBottom: 1 }}
                  entityKey="hyperGatesPro"
                  title={<Entity entity="hyperGatesPro" />}
                  isSelected={location && location.pathname && location.pathname === '/gateways'}
                  onClick={() => dispatch(push('/gateways'))}
                />
              </Permission>
              {systemHasAtlas ? (
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <CollapsibleMenu
                    isOpen={this.state.isGatewayDropdownOpened}
                    headerIcon={<GatewayIcon className={classes.icon} />}
                    headerEntityKey="gateways"
                  headerTitle={<Entity entity="gateways" />}
                    onToggleOpen={isOpen => this.setState({ isGatewayDropdownOpened: isOpen })}
                  >
                    <MenuItem
                      showFavoriteControl
                      path="/gateways"
                      icon={<HyperGateIcon className={classes.icon} />}
                      iconStyle={{ fontSize: 22 }}
                      containerStyle={{ marginBottom: 1 }}
                      entityKey="hyperGatesPro"
                  title={<Entity entity="hyperGatesPro" />}
                      isSelected={location && location.pathname && location.pathname === '/gateways'}
                      onClick={() => dispatch(push('/gateways'))}
                    />
                    <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} abilityHelper={AbilityProvider.getAbilityHelper()}>
                      <MenuItem
                        showFavoriteControl
                        path="/atlas"
                        icon={<AtlasIcon className={classes.icon} />}
                        entityKey="hyperGatesAtlas"
                  title={<Entity entity="hyperGatesAtlas" />}
                        isSelected={location && location.pathname && location.pathname === '/gatewaysAtlas'}
                        onClick={() => dispatch(push('/gatewaysAtlas'))}
                      />
                    </Permission>
                  </CollapsibleMenu>
                </Permission>
              ): (
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/gateways"
                    iconKey="hyperGatesPro"
                    icon={<HyperGateIcon className={classes.icon} />}
                    iconStyle={{ fontSize: 22 }}
                    containerStyle={{ marginBottom: 1 }}
                    title={systemHasAtlas ? <Entity entity="hyperGatesPro" /> : 'HyperGates'}
                    isSelected={location && location.pathname && location.pathname === '/gateways'}
                    onClick={() => dispatch(push('/gateways'))}
                  />
                </Permission>
              )}
              {isHyperTouchManagementActive || isWalletPendingOrReady? (
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.GATEWAY} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/hypertouchDevices"
                    icon={<TabletIcon className={classes.icon} />}
                    iconStyle={{ fontSize: 22 }}
                    containerStyle={{ marginBottom: 1 }}
                    entityKey="hypertouchDevices"
                  title={<Entity entity="hypertouchDevices" />}
                    isSelected={location && location.pathname && location.pathname === '/hypertouchDevices'}
                    onClick={() => dispatch(push('/hypertouchDevices'))}
                  />
                </Permission>
              ) : null}
              
              {(canEditGuestsTags || canEditLocksTags) ?
                <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/tagsManagement"
                    icon={<TagIconCustom className={classes.icon} style={{ width: 27 }} />}
                    iconStyle={{ width: 30 }}
                    entityKey="tagsManagement"
                  title={<Entity entity="tagsManagement" />}
                    isSelected={location && location.pathname && location.pathname === '/tagsManagement'}
                    onClick={() => dispatch(push('/tagsManagement'))}
                  />
                </Permission>
              : null}
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/floorPlans"
                  icon={<MapIconCustom className={classes.icon} />}
                  iconStyle={{ fontSize: 28, width: 28 }}
                  entityKey="floorPlans"
                  title={<Entity entity="floorPlans" />}
                  isSelected={location && location.pathname && location.pathname === '/floorPlans'}
                  onClick={() => dispatch(push('/floorPlans'))}
                />
              </Permission>
              {isCapacityManagementActive && (
                <MenuItem
                  showFavoriteControl
                  path="/areasManagement"
                  icon={<AreasManagementIconCustom className={classes.icon} style={{ width: 22 }} />}
                  entityKey="areasManagement"
                  title={<Entity entity="areasManagement" />}
                  isSelected={location && location.pathname && location.pathname === '/areasManagement'}
                  onClick={() => dispatch(push('/areasManagement'))}
                />
              )}
              {isPrivateUnitsActive && (
                <MenuItem
                  showFavoriteControl
                  path="/privateUnits"
                  icon={<PrivateUnitsIconCustom className={classes.icon} style={{ width: 22 }} />}
                  entityKey="privateUnits"
                  title={<Entity entity="privateUnits" />}
                  isSelected={location && location.pathname && location.pathname === '/privateUnits'}
                  onClick={() => dispatch(push('/privateUnits'))}
                />
              )}
              {isParcelManagementActive && (
                <CollapsibleMenu
                  isOpen={this.state.isParcelDropdownOpen}
                  headerIcon={<PackageIconCustom className={classes.icon} style={{ marginTop: 2, width: 24 }} />}
                  headerEntityKey="parcelManagement"
                  headerTitle={<Entity entity="parcelManagement" />}
                  onToggleOpen={isOpen => this.setState({ isParcelDropdownOpen: isOpen })}
                >
                  <MenuItem
                    showFavoriteControl
                    path="/deliveriesManagement"
                    icon={<PackageCheckIconCustom className={classes.icon} />}
                    entityKey="deliveries"
                  title={<Entity entity="deliveries" />}
                    isSelected={location && location.pathname && location.pathname === '/deliveriesManagement'}
                    onClick={() => dispatch(push('/deliveriesManagement'))}
                  />
                  <MenuItem
                    showFavoriteControl
                    path="/pickupPointsManagement"
                    icon={<PickupPointIconCustom className={classes.icon} style={{ marginTop: 2, width: 20 }} />}
                    entityKey="pickupPointsManagement"
                  title={<Entity entity="pickupPointsManagement" />}
                    isSelected={location && location.pathname && location.pathname === '/pickupPointsManagement'}
                    onClick={() => dispatch(push('/pickupPointsManagement'))}
                  />
                </CollapsibleMenu>
              )}
              {isWearablesManagementActive && (
                <CollapsibleMenu
                  isOpen={this.state.isWearablesDropdownOpen}
                  headerIcon={<PeopleTrackingIconCustom className={classes.icon} style={{ marginTop: 2, width: 24 }} />}
                  headerEntityKey="peopleTracking"
                  headerTitle={<Entity entity="peopleTracking" />}
                  onToggleOpen={isOpen => this.setState({ isWearablesDropdownOpen: isOpen })}
                >
                  {!isCapacityManagementActive ? (
                    <MenuItem
                      showFavoriteControl
                      path="/areasManagement"
                      icon={<AreasManagementIconCustom className={classes.icon} style={{ width: 22 }} />}
                      entityKey="areasManagement"
                  title={<Entity entity="areasManagement" />}
                      isSelected={location && location.pathname && location.pathname === '/areasManagement'}
                      onClick={() => dispatch(push('/areasManagement'))}
                    />
                  ) : null}
                  <MenuItem
                    showFavoriteControl
                    path="/wearablesManagement"
                    icon={<WearableIconCustom className={classes.icon} />}
                    entityKey="trackingDevices"
                  title={<Entity entity="trackingDevices" />}
                    isSelected={location && location.pathname && location.pathname === '/wearablesManagement'}
                    onClick={() => dispatch(push('/wearablesManagement'))}
                  />
                  <MenuItem
                    showFavoriteControl
                    path="/wearableAlarmsManagement"
                    icon={<AlarmIconCustom className={classes.icon} style={{ marginTop: 2, width: 20 }} />}
                    entityKey="wearableAlarms"
                  title={<Entity entity="wearableAlarms" />}
                    isSelected={location && location.pathname && location.pathname === '/wearableAlarmsManagement'}
                    onClick={() => dispatch(push('/wearableAlarmsManagement'))}
                  />
                </CollapsibleMenu>
              )}
              {isIntercomManagementActive && (
                <CollapsibleMenu
                  isOpen={this.state.isIntercomDropdownOpen}
                  headerIcon={<IntercomIconCustom className={classes.icon} style={{ marginTop: 2, width: 24 }} />}
                  headerEntityKey="intercomAppSidebarTitle"
                  headerTitle={<Entity entity="intercomAppSidebarTitle" />}
                  onToggleOpen={isOpen => this.setState({ isIntercomDropdownOpen: isOpen })}
                >
                  <MenuItem
                    showFavoriteControl
                    path="/intercomExtensions"
                    icon={<IntercomExtensionIconCustom className={classes.icon} />}
                    entityKey="intercomExtensionManagement"
                  title={<Entity entity="intercomExtensionManagement" />}
                    isSelected={location && location.pathname && location.pathname === '/intercomExtensions'}
                    onClick={() => dispatch(push('/intercomExtensions'))}
                  />
                  <MenuItem
                    showFavoriteControl
                    path="/intercomManagement"
                    icon={<IntercomManagementIconCustom className={classes.icon} style={{ marginTop: 2, width: 20 }} />}
                    entityKey="intercomManagement"
                  title={<Entity entity="intercomManagement" />}
                    isSelected={location && location.pathname && location.pathname === '/intercomManagement'}
                    onClick={() => dispatch(push('/intercomManagement'))}
                  />
                </CollapsibleMenu>
              )}
              {isVisitorsManagementActive ? (
                <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/visitorsManagement"
                    icon={<VisitorsIconCustom className={classes.icon} />}
                    entityKey="visitorsManagement"
                  title={<Entity entity="visitorsManagement" />}
                    iconStyle={{ width: 22 }}
                    isSelected={location && location.pathname && location.pathname === '/visitorsManagement'}
                    onClick={() => dispatch(push('/visitorsManagement'))}
                  />
                </Permission>
              ) : null}
              {isItemRegistryPluginActive ? (
                <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/registry"
                    icon={<RegistryIcon className={classes.icon} />}
                    entityKey="itemRegistry"
                  title={<Entity entity="itemRegistry" />}
                    iconStyle={{ fontSize: 23 }}
                    isSelected={location && location.pathname && location.pathname === '/itemRegistry'}
                    onClick={() => dispatch(push('/itemRegistry'))}
                  />
                </Permission>
              ) : null}
              {isCommunicationPluginActive ? (
                <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/communications"
                    icon={<CommunicationIconCustom className={classes.icon} />}
                    iconStyle={{ width: 23 }}
                    entityKey="communications"
                  title={<Entity entity="communications" />}
                    isSelected={location && location.pathname && location.pathname === '/communications'}
                    onClick={() => dispatch(push('/communications'))}
                  />
                </Permission>
              ) : null}
            </SidebarSection>
          )}
          {isTicketingManagementActive && (
            <CollapsibleMenu
              isOpen={this.state.isTicketingDropdownOpen}
              headerIcon={<MessageAlertIconCustom className={classes.icon} style={{ marginTop: 2 }} />}
              headerEntityKey="tickets"
                  headerTitle={<Entity entity="tickets" />}
              onToggleOpen={isOpen => this.setState({ isTicketingDropdownOpen: isOpen })}
            >
              <MenuItem
                showFavoriteControl
                path="/tickets"
                icon={<ListBoxIconCustom className={classes.icon} style={{ marginTop: 2 }} />}
                entityKey="ticketsList"
                  title={<Entity entity="ticketsList" />}
                isSelected={location && location.pathname && location.pathname === '/tickets'}
                onClick={() => dispatch(push('/tickets'))}
              />
              <MenuItem
                showFavoriteControl
                path="/ticketAnalytics"
                icon={<AnalyticsIcon className={classes.icon} />}
                entityKey="ticketAnalytics"
                  title={<Entity entity="ticketAnalytics" />}
                isSelected={location && location.pathname && location.pathname === '/ticketAnalytics'}
                onClick={() => dispatch(push('/ticketAnalytics'))}
              />
            </CollapsibleMenu>
          )}
          {!hideCredentialsRulesMenu && (
            <div>
              <h5 className="sidebar-header-custom">
                <Entity entity="credentialRules" />
              </h5>
              <hr className="sidebar-separator" />
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.CREDENTIAL_RULE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/credentials"
                  iconStyle={{ width: 24 }}
                  icon={<SmartPhoneKeyIconCustom className={classes.icon} />}
                  entityKey="smartphones"
                  title={<Entity entity="smartphones" />}
                  isSelected={location && location.pathname && location.pathname === '/credentials'}
                  onClick={() => dispatch(push('/credentials'))}
                />
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.STANDARD_DEVICE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/cards"
                  icon={<CardIcon className={classes.icon} />}
                  entityKey="cards"
                  title={<Entity entity="cards" />}
                  isSelected={location && location.pathname && location.pathname === '/cards'}
                  onClick={() => dispatch(push('/cards'))}
                />
              </Permission>
              <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.STANDARD_DEVICE} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItem
                  showFavoriteControl
                  path="/pins"
                  icon={<PinIconCustom className={classes.icon} />}
                  entityKey="pins"
                  title={<Entity entity="pins" />}
                  isSelected={location && location.pathname && location.pathname === '/pins'}
                  onClick={() => dispatch(push('/pins'))}
                />
              </Permission>
              {isF9000PluginActive ? (
                <Permission do={[PERMISSIONS.READ]} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} on={PERMISSION_ENTITIES.STANDARD_DEVICE} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/hyperKeys"
                    icon={<KeyOutlinedIconCustom className={classes.icon} />}
                    entityKey="mechatronicsKey"
                  title={<Entity entity="mechatronicsKey" />}
                    isSelected={location && location.pathname && location.pathname === '/hyperKeys'}
                    onClick={() => dispatch(push('/hyperKeys'))}
                  />
                </Permission>
              ) : null}
              <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
                <MenuItemRenderer
                  renderCondition={isInvitationPluginActive || isInvitationReadOnlyIntegrationActive}
                  item={
                    <MenuItem
                      showFavoriteControl
                      path="/invitations"
                      icon={<InvitationsIcon className={classes.icon} />}
                      entityKey="invitationsTitle"
                  title={<Entity entity="invitationsTitle" />}
                      isSelected={location && location.pathname && location.pathname === '/invitations'}
                      onClick={() => dispatch(push('/invitations'))}
                    />
                  }
                />
              </Permission>
            </div>
          )}
          <MenuItemRenderer
            renderCondition={isEnergyManagementActive}
            emptyItem={<div />}
            item={
              <div>
                <h5 className="sidebar-header-custom"><Entity entity="energyManagement" /></h5>
                <hr className="sidebar-separator" />
              </div>
            }
          />
          <MenuItemRenderer
            renderCondition={isEnergyManagementActive}
            item={
              <MenuItem
                showFavoriteControl
                path="/energyManagement/dashboard"
                icon={<ChartBoxIconCustom className={classes.icon} style={{ width: 22 }} />}
                entityKey="energyDashboard"
                title={<Entity entity="energyDashboard" />}
                isSelected={location && location.pathname && location.pathname === '/energyManagement/dashboard'}
                onClick={() => dispatch(push('/energyManagement/dashboard'))}
              />
            }
          />
          <MenuItemRenderer
            renderCondition={isEnergyManagementActive}
            item={
              <MenuItem
                showFavoriteControl
                path="/energyManagement/units"
                icon={<EnergyManagementIconCustom className={classes.icon} style={{ width: 22 }} />}
                entityKey="energyManagementUnits"
                title={<Entity entity="energyManagementUnits" />}
                isSelected={location && location.pathname && location.pathname === '/energyManagement/units'}
                onClick={() => dispatch(push('/energyManagement/units'))}
              />
            }
          />
          <MenuItemRenderer
            renderCondition={isEnergyManagementActive}
            item={
              <MenuItem
                showFavoriteControl
                path="/energyManagement/history"
                icon={<History className={classes.icon} style={{ width: 22 }} />}
                entityKey="energyManagementHistory"
                title={<Entity entity="energyManagementHistory" />}
                isSelected={location && location.pathname && location.pathname === '/energyManagement/history'}
                onClick={() => dispatch(push('/energyManagement/history'))}
              />
            }
          />
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isBookeyActive}
              emptyItem={<div />}
              item={
                <div>
                  <h5 className="sidebar-header-custom"><Entity entity="reservationsAndEvents" /></h5>
                  <hr className="sidebar-separator" />
                </div>
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isBookeyActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/resources"
                  icon={<CopyIconCustom className={classes.iconSmall} style={{ width: 21}} />}
                  entityKey="manageResources"
                  title={<Entity entity="manageResources" />}
                  isSelected={location && location.pathname && location.pathname === '/resources'}
                  onClick={() => dispatch(push('/resources'))}
                />
              }
            />
          </Permission>
          {isBookeyCapacityActive ? (
            <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <MenuItemRenderer
                renderCondition={isBookeyActive}
                item={
                  <MenuItem
                    showFavoriteControl
                    path="/availability"
                    icon={<BookeyAvailabilityIconCustom className={classes.icon} />}
                    entityKey="bookeyAvailability"
                  title={<Entity entity="bookeyAvailability" />}
                    isSelected={location && location.pathname && location.pathname === '/availability'}
                    onClick={() => dispatch(push('/availability'))}
                  />
                }
              />
            </Permission>
          ) : null}
          <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isBookeyActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/reservations"
                  icon={<AgendaIconCustom className={classes.icon} />}
                  entityKey="reservations"
                  title={<Entity entity="reservations" />}
                  isSelected={location && location.pathname && location.pathname === '/reservations'}
                  onClick={() => dispatch(push('/reservations'))}
                />
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isBookeyActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/manageEvents"
                  icon={<EventIconCustom className={classes.icon} />}
                  entityKey="manageEvents"
                  title={<Entity entity="manageEvents" />}
                  isSelected={location && location.pathname && location.pathname === '/manageEvents'}
                  onClick={() => dispatch(push('/manageEvents'))}
                />
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
             <MenuItemRenderer
               renderCondition={isBookeyActive}
               item={
                 <MenuItem
                  showFavoriteControl
                  path="/analytics"
                  icon={<AnalyticsIcon className={classes.icon} />}
                  entityKey="analytics"
                  title={<Entity entity="analytics" />}
                  isSelected={location && location.pathname && location.pathname === '/analytics'}
                  onClick={() => dispatch(push('/analytics'))}
                 />
               }
             />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isMksManagementActive}
              emptyItem={<div />}
              item={
                <div>
                  <h5 className="sidebar-header-custom"><Entity entity="mksSystems" /></h5>
                  <hr className="sidebar-separator" />
                </div>
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isMksManagementActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/mksRelations"
                  icon={<GridOnOutlined className={classes.icon} />}
                  entityKey="mksRelations"
                  title={<Entity entity="mksRelations" />}
                  isSelected={location && location.pathname && location.pathname === '/mksRelations'}
                  onClick={() => dispatch(push('/mksRelations'))}
                />
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isMksManagementActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/mksCylinders"
                  icon={<DoorClosedIconCustom className={classes.iconSmall} style={{ width: 24 }} />}
                  entityKey="mksCylinders"
                  title={<Entity entity="mksCylinders" />}
                  isSelected={location && location.pathname && location.pathname === '/mksCylinders'}
                  onClick={() => dispatch(push('/mksCylinders'))}
                />
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isMksManagementActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/mksKeys"
                  icon={<TableKeyIconCustom className={classes.icon} style={{ width: 24 }} />}
                  entityKey="mksKeys"
                  title={<Entity entity="mksKeys" />}
                  isSelected={location && location.pathname && location.pathname === '/mksKeys'}
                  onClick={() => dispatch(push('/mksKeys'))}
                />
              }
            />
          </Permission>
          <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.ON_PREMISE]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isMksManagementActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/requests"
                  icon={<CommentOutlined className={classes.icon} />}
                  entityKey="mksRequests"
                  title={<Entity entity="mksRequests" />}
                  isSelected={location && location.pathname && location.pathname === '/mksRequests'}
                  onClick={() => dispatch(push('/mksRequests'))}
                />
              }
            />
          </Permission>
          {canReadLogs && (
            <Permission withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <div>
                <h5 className="sidebar-header-custom">
                  <Entity entity="manageEvents" />
                </h5>
                <hr className="sidebar-separator" />
                <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.LOG} abilityHelper={AbilityProvider.getAbilityHelper()}>
                  <MenuItem
                    showFavoriteControl
                    path="/adminEvents"
                    icon={<AdminEventsIconCustom className={classes.icon} />}
                    iconStyle={{ width: 24 }}
                    entityKey="adminEvents"
                  title={<Entity entity="adminEvents" />}
                    isSelected={location && location.pathname && location.pathname === '/adminEvents'}
                    onClick={() => dispatch(push('/adminEvents'))}
                  />
                </Permission>
                {hasSharedLocks ? (
                  <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.SMART_LOCK} abilityHelper={AbilityProvider.getAbilityHelper()}>
                    <CollapsibleMenu
                      isOpen={this.state.isEventsDropdownOpened}
                      headerIcon={<SmartLocksEventsIconCustom className={classes.icon} />}
                      headerEntityKey="doorEvents"
                  headerTitle={<Entity entity="doorEvents" />}
                      onToggleOpen={isOpen => this.setState({ isEventsDropdownOpened: isOpen })}
                    >
                      <MenuItem
                        showFavoriteControl
                        path="/smartLockEvents"
                        iconStyle={{ width: 25 }}
                        icon={(
                          <div style={{ position: 'relative' }}>
                            <Domain className={classes.icon} style={{ position: 'absolute', bottom: 2, fontSize: 15, right: -7 }} />   
                            <SubcompanyEventIconCustom className={classes.icon} />
                          </div>
                        )}
                        title={<Entity entity={getPlantName()} />}
                        isSelected={location && location.pathname && location.pathname === '/smartLockEvents'}
                        onClick={() => dispatch(push('/smartLockEvents'))}
                      />
                      {_.map(subcompanies, subcompany => (
                        <MenuItem
                          showFavoriteControl
                          path="/subcompaniesSmartLockEvents"
                          icon={(
                            <div style={{ position: 'relative' }}>
                              <Domain className={classes.icon} style={{ position: 'absolute', bottom: 2, fontSize: 15, right: -7 }} />   
                              <SubcompanyEventIconCustom className={classes.icon} />
                            </div>
                          )}
                          iconStyle={{ width: 24 }}
                          title={<Entity entity={subcompany.plantName} />}
                          isSelected={location && location.pathname && location.pathname === '/subcompaniesSmartLockEvents' && location.search === `?subcompanyId=${subcompany.id}`}
                          onClick={() => dispatch(push(`/subcompaniesSmartLockEvents?subcompanyId=${subcompany.id}`))}
                        />
                      ))}
                    </CollapsibleMenu>
                  </Permission>
                ) : (
                  <MenuItem
                    showFavoriteControl
                    path="/smartLockEvents"
                    iconStyle={{ width: 25 }}
                    icon={<SmartLocksEventsIconCustom className={classes.icon} />}
                    entityKey="doorEvents"
                  title={<Entity entity="doorEvents" />}
                    isSelected={location && location.pathname && location.pathname === '/smartLockEvents'}
                    onClick={() => dispatch(push('/smartLockEvents'))}
                  />
                )}
              </div>
            </Permission>
          )}
          <h5 className="sidebar-header-custom">
            <Entity entity="platformManagement" />
          </h5>
          <hr className="sidebar-separator" />
          <Permission do={[PERMISSIONS.ALL]} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.ON_PREMISE]} on={PERMISSION_ENTITIES.ACCESS_PROFILES} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItemRenderer
              renderCondition={isAccessProfileAddonActive}
              item={
                <MenuItem
                  showFavoriteControl
                  path="/accessProfiles"
                  icon={<AccessProfilesIconCustom className={classes.icon} />}
                  entityKey="accessProfiles"
                  title={<Entity entity="accessProfiles" />}
                  isSelected={location && location.pathname && location.pathname === '/accessProfiles'}
                  onClick={() => dispatch(push('/accessProfiles'))}
                />
              }
            />
          </Permission>
          <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItem
              showFavoriteControl
              path="/platformUsers"
              iconStyle={{ width: 25 }}
              icon={<PlatformUserIconCustom className={classes.icon} />}
              entityKey="platformUsers"
                  title={<Entity entity="platformUsers" />}
              isSelected={location && location.pathname && location.pathname === '/platformUsers'}
              onClick={() => dispatch(push('/platformUsers'))}
            />
          </Permission>
          <Permission do={[PERMISSIONS.READ]} on={PERMISSION_ENTITIES.USER} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.LITE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItem
              showFavoriteControl
              path="/installers"
              iconStyle={{ width: 25 }}
              icon={<InstallerOutlinedIconCustom className={classes.icon} style={{ width: 24 }} />}
              entityKey="installers"
                  title={<Entity entity="installers" />}
              isSelected={location && location.pathname && location.pathname === '/installers'}
              onClick={() => dispatch(push('/installers'))}
            />
          </Permission>
          <Permission do={[PERMISSIONS.READ]} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.ON_PREMISE]} on={PERMISSION_ENTITIES.ROLE} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MenuItem
              showFavoriteControl
              path="/roles"
              iconStyle={{ fontSize: 23 }}
              icon={<RolesIcon className={classes.icon} />}
              entityKey="rolesAndPermissions"
                  title={<Entity entity="rolesAndPermissions" />}
              isSelected={location && location.pathname && location.pathname === '/roles'}
              onClick={() => dispatch(push('/roles'))}
            />
          </Permission>
          {isCustomTablesActive && (
            <Permission do={[PERMISSIONS.READ]} withLicenses={[LICENSE_TYPES.ENTERPRISE, LICENSE_TYPES.LITE, LICENSE_TYPES.ENGINE, LICENSE_TYPES.RFID, LICENSE_TYPES.ON_PREMISE]} on={PERMISSION_ENTITIES.ROLE} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <MenuItem
                showFavoriteControl
                path="/customTables"
                icon={<GridOn className={classes.icon} />}
                entityKey="customTables"
                  title={<Entity entity="customTables" />}
                isSelected={location && location.pathname && location.pathname === '/customTables'}
                onClick={() => dispatch(push('/customTables'))}
                />
            </Permission>
          )}
          {isCustomActionsActive && (
            <Permission do={[PERMISSIONS.READ]} withLicenses={[LICENSE_TYPES.ENTERPRISE]} on={PERMISSION_ENTITIES.ROLE} abilityHelper={AbilityProvider.getAbilityHelper()}>
              <MenuItem
                showFavoriteControl
                path="/customSnippets"
                icon={<SnippetIcon className={classes.icon} />}
                entityKey="customSnippets"
                  title={<Entity entity="customSnippets" />}
                isSelected={location && location.pathname && location.pathname === '/customSnippets'}
                onClick={() => dispatch(push('/customSnippets'))}
                />
            </Permission>
          )}
          {isMarketPlaceEnabled && !isFakeCloudCredits ? (
            <MenuItem
              showFavoriteControl
              path="/luckeyStore"
              icon={<StoreOutlinedIconCustom className={classes.iconBig} />}
              entityKey="luckeyStore"
                  title={<Entity entity="luckeyStore" />}
              isSelected={location && location.pathname && location.pathname === '/luckeyStore'}
              onClick={() => dispatch(push('/luckeyStore'))}
            />
          ) : null}
          <MenuItem
            showFavoriteControl
            path="/settings"
            icon={<SettingsIcon className={classes.icon} />}
            entityKey="settings"
                  title={<Entity entity="settings" />}
            isSelected={location && location.pathname && (location.pathname === '/settings' || location.pathname === '/settings/octorate')}
            onClick={() => dispatch(push('/settings'))}
          />
          {licenseType !== LICENSE_TYPES.ON_PREMISE && licenseType !== LICENSE_TYPES.LITE && licenseType !== LICENSE_TYPES.RFID && companyLogo ? (
            <div style={{ paddingRight: 10, paddingBottom: 20, marginTop: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              {companyLogo && <img src={companyLogo} alt="logo" style={{ width: 120, alignSelf: 'center' }} />}
            </div>
          ) : null}
        </List>
    );
    return (
      <SidebarThemeRoot themeName={themeName}>
        <SidebarNavContext.Provider value={sidebarNavContextValue}>
          <SidebarSearchField
            value={sidebarSearchQuery}
            onChange={this.onSidebarSearchChange}
          />
          <SidebarFavoritesSection
            favorites={sidebarFavorites}
            location={location}
            dispatch={dispatch}
            push={push}
            getFavoriteIcon={this.getFavoriteIcon}
            classes={classes}
          />
          {navContent}
        </SidebarNavContext.Provider>
      </SidebarThemeRoot>
    );
  }
}

export default withStyles(styles)(AppSidebar);